import { Entity, System } from "ecsy";
import { Cooldown, CooldownReserve } from "../components";
import { BehaviorsConstants, PhysicsConstants } from "../constants";
import { Game } from "../game";

export class CooldownSystem extends System {
	private game: Game;

	constructor(world: any, attributes: any) {
		// @ts-ignore
		super(world, attributes);
		this.game = attributes.game;
	}

	execute() {
		if (!this.game.inSimulation) return;

		const depletedReserves = new Array<Entity>();
		for (const entity of this.queries.reserves.results) {
			const reserve = entity.getComponent(CooldownReserve);
			const cooldown = entity.getComponent(Cooldown);
			const maxReduction = cooldown.remaining - BehaviorsConstants.MinCooldown;
			if (maxReduction > 0) {
				const reduction = Math.min(maxReduction, reserve.reserve);
				cooldown.remaining -= reduction;
				reserve.reserve -= reduction;
			}
			if (reserve.reserve === 0) {
				depletedReserves.push(entity);
			}
		}

		for (const entity of depletedReserves) {
			entity.removeComponent(CooldownReserve);
		}

		for (const entity of this.queries.cooldown.results) {
			const cooldown = entity.getComponent(Cooldown);
			if (cooldown.restarted) {
				cooldown.remaining = cooldown.cooldown;
				cooldown.done = false;
				cooldown.restarted = false;
			}

			if (cooldown.extra > 0) {
				cooldown.extra = Math.max(0, cooldown.extra - PhysicsConstants.StepRate);
			}
			else if (cooldown.remaining > 0) {
				cooldown.remaining = Math.max(0, cooldown.remaining - PhysicsConstants.StepRate);
			}
			else if (cooldown.remaining === 0 && !cooldown.done) {
				cooldown.done = true;
			}
		}

	}

}

CooldownSystem.queries = {
	cooldown: { components: [Cooldown] },
	reserves: { components: [CooldownReserve, Cooldown] },
}